/**
 * @file paddlejs case
 * @author wanzhongyun
 */

import React, { useState } from 'react';
import { IPaddleJsCase, IPaddleJsCaseBtnItem } from './../../type';
import { Button, Modal } from 'antd';

import './style.less';


const PaddleJSCase: React.FC<IPaddleJsCase> = props => {

    const { title, caseList } = props;
    const [visible, setVisible] = useState<boolean>(false);
    const [currentQRCode, setCurrentQRCode] = useState<string>('');
    
    const handleBtnClick = (ele: IPaddleJsCaseBtnItem) => {
        if (!!ele.btnLink) {
            window.open(ele.btnLink, '_blank');
        }
        else {
            setVisible(true);
            setCurrentQRCode(ele.QRCodeImageUrl ?? '');
        }
    };

    return <div className='paddle-js-case-wrapper'>
        <div className='paddle-js-case'>{ title }</div>
        <div className='paddle-js-case-card-wrapper'>
            {
                caseList.map(item => <div className='paddle-js-case-card' key={item.title} >
                    <img className='paddle-js-case-card-image' src={item.imageUrl} alt={item.title} />
                    <div className='paddle-js-case-card-content-wrapper'>
                        <div className='paddle-js-case-card-title'>{ item.title }</div>
                        <div className='paddle-js-case-card-desc'>{ item.desc }</div>
                        {
                            item.btnList.map(ele => <Button
                                    key={ele.btnWord}
                                    className='case-btn-item'
                                    onClick={() => handleBtnClick(ele)}
                                    disabled={ele.btnStatus !== '可用'}
                                    type='link'
                            >
                                {ele.btnWord}
                            </Button>)
                        }
                    </div>
                </div>)
            }
        </div>

        <Modal
            className='case-modal-style'
            title='立即体验'
            visible={visible}
            onCancel={() => setVisible(false)}
            footer={null}
        >
            <img className='case-modal-qr-code-image' src={currentQRCode} alt={currentQRCode} />
            <div className='case-modal-qr-code-tips'>扫描二维码</div>
            <div className='case-modal-qr-code-tips tips-padding'>打开百度APP体验</div>
        </Modal>

    </div>
};

export default PaddleJSCase;